var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.251H3.414L5.707 2.81a1.07 1.07 0 00.224-.346A1.125 1.125 0 005.72 1.29a.998.998 0 00-.328-.233.947.947 0 00-.773.007 1.001 1.001 0 00-.325.239l-4 4.26a1.072 1.072 0 00-.217.346 1.126 1.126 0 00.217 1.163l4 4.26a.97.97 0 00.708.312.97.97 0 00.707-.313c.188-.2.293-.47.293-.753 0-.283-.106-.554-.294-.754L3.414 7.382H11a.97.97 0 00.707-.312c.188-.2.293-.47.293-.753 0-.283-.105-.554-.293-.754A.97.97 0 0011 5.251z",
    fill: "#000"
  })));
}
export default SvgArrowLeft;